import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import purchaseService from "../Services/purchaseService";
import { IoClose } from "react-icons/io5";
import Dropdown from "../Components/Dropdown";

const PurchasePayment = ({ isOpen, onClose, purchase }) => {
  const [amount, setAmount] = useState(0);
  const [method, setMethod] = useState("");
  const [date, setDate] = useState(0);
  const [note, setNote] = useState(purchase?.reference);
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (amount > 0 && method) {
      purchaseService
        .makePayment(purchase.id, {
          paid_amount: amount,
          method: method,
          date: date,
          note: note,
        })
        .then((response) => {
          if (response.responseCode === 200) {
            onClose();
            toast.success("Transaction Added");
            navigate("/purchase", { replace: true });
          } else {
            toast.success("Transaction Failed");
          }
        });
    } else {
      toast.error("Enter valid amount and method");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black  bg-opacity-50 w-[100%] mx-auto">
      <div className="bg-white h-[450px] rounded-3xl p-4 w-[60%]">
        <div className="flex justify-end">
          <button
            className="bg-red-500 p-1 rounded-full"
            onClick={() => onClose()}
          >
            <IoClose className="text-white" />
          </button>
        </div>
        <div className="mb-2 mt-4">
          <h1 className="flex justify-center font-bold text-2xl text-secondary">
            Enter Amount to Order
          </h1>
        </div>
        <div className="flex flex-col justify-center space-y-4 px-12 py-10">
          <div className="grid grid-cols-1 gap-2 md:grid-cols-3 md:gap-4">
            <div>
              <label className="primary-label">Select a Date</label>
              <input
                type="date"
                name="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                placeholder="Enter Amount "
                className={`primary-input`}
              />
            </div>
            <div>
              <label className="primary-label"> Enter an Amount </label>
              <input
                type="number"
                name="amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="Enter Amount "
                className={`primary-input`}
              />
            </div>
            <div>
              <label className="primary-label"> Select a payment method </label>
              <Dropdown
                selected={method || ""}
                placeholder="Select a payment Method"
                onChange={(value) => setMethod(value)}
                options={[
                  { label: "Cash", value: "CASH" },
                  { label: "Bank", value: "BANK" },
                  { label: "Cheque", value: "CHEQUE" },
                  { label: "Card", value: "CARD" },
                ]}
              />
            </div>
          </div>
          <div>
            <label className="primary-label"> Enter a Specific Note</label>
            <textarea
              type
              name="note"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Enter a Note "
              className={`primary-input`}
            />
          </div>

          <div className="flex justify-center space-x-3 pt-10">
            <button className={`button-primary`} onClick={() => handleSubmit()}>
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchasePayment;
